import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import Shelf from '../../components/widgets/Shelf';
import Spinner from '../../components/widgets/Spinner';
import { IconSizes } from '../../components/foundations/Icon';
import ChatConversation from '../../chatView/components/ChatConversation';
import VerdictBadge from './VerdictBadge';
import EditablePrompt from './EditablePrompt';
import { TRANSLATION_KEY } from '../constants';
import { monitorShape, verdictShape } from '../propShapes';
import { formatFirstRunLabel } from '../utils';
import css from './ThreadShelf.css';

const SHELF_KEY = `${TRANSLATION_KEY}.SHELF`;

const ThreadShelf = ({
    open,
    monitor = null,
    verdict = null,
    chat,
    onClose,
    onSavePrompt,
}) => {
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        setIsEditing(false);
    }, [monitor?.monitor_id]);

    const sessionReady =
        monitor != null && chat.loadingSessionId == null && chat.currentSessionId === monitor.session_id;
    const firstRunLabel = monitor && formatFirstRunLabel(monitor.next_run_at);

    return (
        <Shelf
            open={open}
            onClose={onClose}
            headerText={`${SHELF_KEY}.TITLE`}
            shelfSize="xlarge"
            enterAnimationDisabled={false}
            contentContainerClass={css.shelfContent}
        >
            {monitor && (
                <div className={css.container}>
                    <div className={css.header}>
                        <div className={css.badgeRow}>
                            <VerdictBadge verdict={verdict} />
                        </div>
                        <EditablePrompt
                            isEditing={isEditing}
                            onEditStart={() => setIsEditing(true)}
                            onEditDone={() => setIsEditing(false)}
                            prompt={monitor.user_query}
                            onSave={onSavePrompt}
                            rowClassName={css.titleRow}
                            textClassName={css.title}
                            editorClassName={css.promptEditor}
                            iconSize={IconSizes.LARGE}
                            iconClassName={css.editIcon}
                        />
                    </div>
                    <div className={css.conversation}>
                        {!sessionReady && <Spinner show />}
                        {sessionReady && !chat.messages.length && (
                            <div className={css.emptyThread}>
                                {firstRunLabel ? (
                                    <Translate id={`${TRANSLATION_KEY}.CARD.FIRST_RUN`} data={{ firstRunLabel }} />
                                ) : (
                                    <Translate id={`${TRANSLATION_KEY}.CARD.NO_RUNS_YET`} />
                                )}
                            </div>
                        )}
                        {sessionReady && chat.messages.length > 0 && <ChatConversation chat={chat} />}
                    </div>
                </div>
            )}
        </Shelf>
    );
};

ThreadShelf.propTypes = {
    open: PropTypes.bool.isRequired,
    monitor: monitorShape,
    verdict: verdictShape,
    chat: PropTypes.shape({
        messages: PropTypes.arrayOf(PropTypes.object).isRequired,
        currentSessionId: PropTypes.string,
        loadingSessionId: PropTypes.string,
    }).isRequired,
    onClose: PropTypes.func.isRequired,
    onSavePrompt: PropTypes.func.isRequired,
};

export default ThreadShelf;
